var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoginWaves = function SvgLoginWaves(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1690 258"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#LoginWaves_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DDEDF4",
    d: "M806.943 162.813c-196.936 8.668-313.682-54.182-506.297-19.815C162.865 167.582-28.001 258-28.001 258H1691V.626c-7.62-.159-15.41-.286-23.38-.383-358.6-4.365-508.41 147.066-860.677 162.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCE4EE",
    d: "M967.839 199.803c-203.25 8.841-321.929-31.593-522.528-20.21C241.695 191.148 147.033 220.729 57.949 258H1691V43.125c-260.73 32.932-418.65 143.434-723.161 156.678"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99C8DC",
    d: "M1233.91 237.871c-203.27 6.112-321.966-21.842-522.587-13.972C564.304 229.666 474.081 241.93 401.749 258H1691v-85.95c-135.64 28.579-268.16 60.141-457.09 65.821"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "LoginWaves_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1691v258H0z"
  })))));
};
export default SvgLoginWaves;